import { withRouter } from 'react-router-dom';
import { Text } from '@shopify/polaris';
import './index.scss';
import Language from '../../i18n/Language';
const t = Language;

// 升级图标
const PlanLockBlock = (props) => {
    const {
        plan,
        upgradeShow,
    } = props;

    return <div className='PAY_ICON' onClick={upgradeShow}>
        <Text variant="bodySm" as="p">{plan === 1 ? t("Pro plan unlock") : t("Pre plan unlock")}</Text>
        <span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1Z" fill="var(--color-primary)" />
                <path d="M8.75 11.5C8.75 11.9142 8.41421 12.25 8 12.25C7.58579 12.25 7.25 11.9142 7.25 11.5V6.31066L6.03033 7.53033C5.73744 7.82322 5.26256 7.82322 4.96967 7.53033C4.67678 7.23744 4.67678 6.76256 4.96967 6.46967L7.46967 3.96967C7.76256 3.67678 8.23744 3.67678 8.53033 3.96967L11.0303 6.46967C11.3232 6.76256 11.3232 7.23744 11.0303 7.53033C10.7374 7.82322 10.2626 7.82322 9.96967 7.53033L8.75 6.31066V11.5Z" fill="white" />
            </svg>
        </span>
    </div>
}

export default withRouter(PlanLockBlock);